export default {
  currentName: 'Background Management System',
  total: 'total',
  date: 'date',
  search: 'Search',
  clear: 'Clear',
  reset: 'Reset',
  create: 'Create',
  edit: 'Edit',
  delete: 'Delete',
  batchDelete: 'Batch delete',
  inputPleaseEnter: 'Please enter',
  inputPleaseSelect: 'Please select',
  createTitle: 'Add {{title}}',
  editTitle: 'Edit {{title}}',
  pleaseEnter: 'Enter {{name}}',
  pleaseSelect: 'Select {{name}}',
  confirmMessage: 'Are you sure you want to {{name}}?',
  deleteConfirmMessage: 'Are you sure you want to delete {{name}}?',
  batchDeleteConfirmMessage: 'Are you sure you want to batch delete {{name}}?',
  successfulOperation: 'Successful operation',
  successfullyDeleted: 'Successfully deleted',
  checkAll: 'Check all',
  checkAllWarning: 'Table filter must check one',
  fullScreen: 'Full screen',
  exitFullscreen: 'Exit fullscreen',
  themes: 'Themes',
  changePassword: 'Change Password',
  signOut: 'Sign Out',
  signOutMessage: 'Are you sure to log out of the system?',
  kindTips: 'Kind Tips',
  reload: 'Reload',
  closeTab: 'Close tab',
  closeOther: 'Close other',
  closeLeft: 'Close left',
  closeRight: 'Close right',
  confirm: 'Confirm',
  cancel: 'Cancel',
  operate: 'operate',
  submit: 'Submit',
  open: 'Open',
  close: 'Close',
  back: 'Go back',
  show: 'Show',
  hide: 'Hide',
  ok: 'OK',
  copy: 'Copy',
  copySuccessfully: 'Copy successfully',
  copyFailed: 'Copy failed',
  maximize: 'Maximize',
  exitMaximized: 'Exit maximized',
  totalNum: 'A total of {{num}} data',
  name: 'name',
  creationTime: 'Creation time',
  updateTime: 'Update time',
  columnFilter: 'Column filter',
  refresh: 'Refresh',
  refreshSuccessfully: 'Refresh successfully',
  notSearchContent: 'There is no search content',
  switch: 'Switch',
  content: 'Content',
  title: 'Title',
  type: 'Type',
  refreshPage: 'Refresh page',
  returnHome: 'Return home',
  pageErrorTitle: 'Page error',
  reloadPageMsg: 'New content found, automatically updating...',
  pagepageErrorSubTitle:
    'Sorry, an error has occurred on this page and the content cannot be displayed properly.',
  notPermissionMessage:
    'The current page cannot be accessed, it may not have permission or has been deleted!',
  notFindMessage:
    'The current page cannot be accessed, it may not have permission or has been deleted',
  requiredForm: '{{label}} is required!',
  validateEmail: '{{label}} is not a valid email!',
  validateNumber: '{{label}} is not a valid number!',
  validateRange: '{{label}} must be between {{min}} and {{max}}',
  createMethodWarning: 'The new component lacks a corresponding method',
  getPageWarning: 'Missing page acquisition method',
  tableSelectWarning: 'Please select table data',
  menuSearchPlaceholder: 'Please enter the menu name',
  noMoreData: 'No more data',
  noLoginVisit: 'Cannot access without login',
  loading: 'Loading',
  uploadFile: 'Upload File',
};
